const apiConfig = {
  auth: {
    signUp: 'auth/signup/',
    login: 'auth/jwt/token/',
    logout: 'auth/logout/',
    googleLogin: 'auth/google/login/',
    wechatLogin: 'auth/wechat/login/',
    refresh: 'auth/jwt/token/refresh/',
    authenticationCheck: 'auth/authentication-check/',
    resetPasswordRequest: 'auth/request-password-reset/',
    resetPasswordVerify: 'auth/verify-password-reset-token/',
    resetPassword: 'auth/reset-password/',
    sendVerifyEmail: 'auth/regenerate-email-token/',
    adminSendVerifyEmail: 'auth/admin-regenerate-email-token/',
    userInfo: 'auth/user-info/',
    emailVerificationCheck: 'auth/email-verification-check/',
    enroll: 'courses/enroll/',
    verifyEmail: 'auth/verify-email-token/',
    setOnboarding: 'auth/onboarding/',
    sendTimezone: 'auth/timezone/',
    setLanguage: 'auth/language/',
    readPetLetter: 'auth/read-pet-letter/',
    adminAddStudent: 'auth/student/',
    adminAddStudents: 'auth/add-students/',
    adminAddTeacher: 'auth/teacher/',
    adminStudentInvite: 'auth/student/invite',
    adminTeacherInvite: 'auth/teacher/invite',
    billingUsage: 'auth/usage/',
    getAcademyLogoFromDomain: 'auth/logo-domain',
    getTeacherStripeDetails: '/auth/stripe-details/',
    zoomAuth: 'zoom-auth/',
    getEncryptedUserId: 'zoom-auth/user-id/',
    zoomAuthReturn: 'zoom-auth/return',
  },
  courses: {
    getAllCourses: '/courses/list/',
    getAllCoursesMinimal: '/courses/list/minimal/',
    create: '/courses/create/',
    edit: (courseId: string) => `/courses/${courseId}/edit/`,
    delete: (courseId: string) => `/courses/${courseId}/delete/`,
    CourseInfo: (courseId: string) => `/courses/${courseId}/`,
    listStudents: (courseId: string) => `/courses/${courseId}/students/`,
    getStudentsXPLevels: (courseId: string) =>
      `/courses/${courseId}/students/xp-levels/`,
    removeStudent: (courseId: string) => `/courses/${courseId}/student/remove/`,
    addStudent: (courseId: string) => `/courses/${courseId}/invite/mail/`,
    listLessons: (courseId: string) => `/courses/${courseId}/lessons/`,
    archive: (courseId: string) => `/courses/${courseId}/archive/`,
    unarchive: (courseId: string) => `/courses/${courseId}/unarchive/`,
    startZoom: (courseId: string) => `/zoom/course/${courseId}/start/`,
  },
  quizzes: {
    getAll: '/quizzes/',
    handleQuiz: (quizId: string) => `/quizzes/${quizId}/`,
    questions: (quizId: string) => `/quizzes/${quizId}/questions/`,
    handleQuestion: (quizId: string, questionId: string) =>
      `/quizzes/${quizId}/questions/${questionId}/`,
    answers: (quizId: string, questionId: string) =>
      `/quizzes/${quizId}/questions/${questionId}/answers/`,
    handleAnswer: (quizId: string, questionId: string, answerId: string) =>
      `/quizzes/${quizId}/questions/${questionId}/answers/${answerId}/`,
    changeOrder: (quizId: string) =>
      `/quizzes/${quizId}/questions/change-order/`,
    getQuizData: (quizId: string) => `/quizzes/${quizId}/`,
    folders: '/quizzes/folders/',
    handleFolder: (folderId: string) => `/quizzes/folder/${folderId}/`,
  },
  lessons: {
    list: '/lessons/list/',
    create: '/lessons/create/',
    listStudentLessons: '/lessons/student',
    fetchLesson: (lessonId: string) => `/lessons/${lessonId}/`,
    checkForExistingLesson: (courseId: string) =>
      `/lessons/check-existing/${courseId}/`,
    end: (lessonId: string) => `/lessons/${lessonId}/end/`,
    finish: '/lessons/finish/',
    markFinished: '/lessons/mark-finished/',
    submitFeedback: '/lessons/submit-feedback/',
    edit: (lessonId: string) => `/lessons/${lessonId}/edit/`,
    changeName: (lessonId: string) => `/lessons/${lessonId}/change-name/`,
    addStudent: (lessonId: string) => `/lessons/${lessonId}/add-student/`,
    addTeacher: (lessonId: string) => `/lessons/${lessonId}/add-teacher/`,
    launchQuiz: (lessonId: string, quizId: string) =>
      `/lessons/${lessonId}/quiz/${quizId}/launch/`,
    submitQuizMode: (lessonId: string, quizSessionId: string) =>
      `/lessons/${lessonId}/quiz-session/${quizSessionId}/submit-quiz-mode/`,
    registerStudentQuizParticipation: (
      lessonId: string,
      quizSessionId: string
    ) => `/lessons/${lessonId}/quiz-session/${quizSessionId}/participants/`,
    fetchQuizStatus: (lessonId: string, quizSessionId: string) =>
      `/lessons/${lessonId}/quiz-session/${quizSessionId}/status/`,
    submitAnswer: (lessonId: string, quizSessionId: string) =>
      `/lessons/${lessonId}/quiz-session/${quizSessionId}/submit-answer/`,
    goToNextQuestion: (lessonId: string, quizSessionId: string) =>
      `/lessons/${lessonId}/quiz-session/${quizSessionId}/next-question/`,
    showQuizResults: (lessonId: string, quizSessionId: string) =>
      `/lessons/${lessonId}/quiz-session/${quizSessionId}/show-quiz-results/`,
    endQuiz: (lessonId: string, quizSessionId: string) =>
      `/lessons/${lessonId}/quiz-session/${quizSessionId}/end-quiz/`,
    startQuiz: (lessonId: string, quizSessionId: string) =>
      `/lessons/${lessonId}/quiz-session/${quizSessionId}/start-quiz/`,
    joinQuiz: (lessonId: string, quizSessionId: string) =>
      `/lessons/${lessonId}/quiz-session/${quizSessionId}/join-quiz/`,
    getActiveQuiz: (lessonId: string) =>
      `/lessons/${lessonId}/check-active-quiz/`,
    getCurrentQuestion: (lessonId: string, quizSessionId: string) =>
      `/lessons/${lessonId}/quiz-session/${quizSessionId}/current-question/`,
    editQuizSessionResponseCorrectness: (
      lessonId: string,
      quizSessionId: string
    ) =>
      `/lessons/${lessonId}/quiz-session/${quizSessionId}/edit-response-correctness/`,
    startBadgeReward: (lessonId: string) =>
      `/lessons/${lessonId}/reward-badge/launch/`,
    startUnderstandingCheck: (lessonId: string) =>
      `/lessons/${lessonId}/start-understanding-check/`,
    submitUnderstandingCheck: (lessonId: string) =>
      `/lessons/${lessonId}/submit-understanding-check/`,
    endUnderstandingCheck: (lessonId: string) =>
      `/lessons/${lessonId}/end-understanding-check/`,
    listStudents: (lessonId: string) => `/lessons/${lessonId}/students/`,
    launchBadgeReward: (lessonId: string) =>
      `/lessons/${lessonId}/reward-badge/launch/`,
    submitBadgeReward: (lessonId: string) =>
      `/lessons/${lessonId}/reward-badge/submit/`,
    getBadgeRewards: (lessonId: string, student_id = '') =>
      `/lessons/${lessonId}/reward-badge/list/${
        student_id ? `${student_id}/` : ''
      }`,
    endBadgeReward: (lessonId: string) =>
      `/lessons/${lessonId}/reward-badge/end/`,
    getLeaderboard: (lessonId: string) => `/lessons/${lessonId}/leaderboard/`,
    getChestXPAmount: (lessonId: string) =>
      `/lessons/${lessonId}/reward-chest/`,
    launchPodium: (lessonId: string) => `/lessons/${lessonId}/launch-podium/`,
    notifyInactivity: (lessonId: string) => `/lessons/${lessonId}/inactivity/`,
    getTeacherReview: '/lessons/teacher-review/',
    submitTeacherReview: '/lessons/teacher-review/submit/',
    getStudentReview: '/lessons/student-review/',
    submitStudentReview: '/lessons/student-review/',
    removeStudentReview: '/lessons/student-review/',
    editStudentReview: '/lessons/student-review/',
    coBrowser: '/lessons/co-browser/',
    updateName: (lessonId: string) => `/lessons/${lessonId}/change-name/`,
    lessonHistory: '/lessons/history',
    lessonHistoryCourse: (courseId: string) => `/lessons/history/${courseId}/`,
    coBrowserDetails: '/lessons/co-browser/details/',
    convertXpToCoin: (student_id: string, course_id: string) =>
      `/lessons/convert-xp-to-coin/${student_id}/${course_id}/`,
  },
  levels: {
    listStudentsLevel: '/levels/listStudentsLevel/',
    listPetsLevel: '/levels/listPetsLevel/',
  },
  rewards: {
    giveReward: '/rewards/',
    getReward: '/rewards/leaderboard-reward/',
  },
  profiles: {
    getBadges: '/profiles/won-badges/',
    getAttendance: '/profiles/attendance/',
    getPerformanceGraph: '/profiles/performance-graph/',
    setLastAcknowledgedLevel: '/auth/acknowledge-level/',
    getLastLessonXP: '/profiles/last-lesson-xp/',
    coinNotification: '/profiles/last-lesson-xp/',
  },
  pets: {
    setPetName: '/pets/',
    getPetInfo: '/pets/',
    revive: '/pets/revive/',
  },
  bigbluebutton: {
    create: '/bbb/create/',
    join: '/bbb/join/',
    end: '/bbb/end/',
    getMeetingInfo: '/bbb/info/',
    getRecordings: '/bbb/recordings/',
    insertDocument: (courseId: string) => `/bbb/insert-document/${courseId}/`,
    isMeetingRunning: (courseId: string) =>
      `/bbb/is-meeting-running/${courseId}/`,
    deleteRecording: '/bbb/delete-recording/',
  },
  scheduling: {
    schedule: '/scheduling/',
    lessons: '/scheduling/lesson/',
    reschedule: '/scheduling/reschedule/',
    approveReschedule: (rescheduleRequestId: string) =>
      `/scheduling/reschedule/${rescheduleRequestId}/approve/`,
    rejectReschedule: (rescheduleRequestId: string) =>
      `/scheduling/reschedule/${rescheduleRequestId}/reject/`,
    suggestReschedule: (rescheduleRequestId: string) =>
      `/scheduling/reschedule/${rescheduleRequestId}/suggest/`,
    adminRescheduleLesson: (scheduledLessonId: string) =>
      `/scheduling/reschedule/${scheduledLessonId}/admin-reschedule/`,
    calendar: '/scheduling/calendar/',
    submitAvailability: '/scheduling/availability/',
    getAvailability: '/scheduling/availability/',
  },
  upload: {
    presignedUrl: '/upload/presigned-url/',
    courseMaterial: '/upload/course-material/',
    quizImage: '/upload/quiz-image/',
    getCourseMaterial: '/upload/course-material/',
    // deleteCourseMaterial: '/upload/course-material/',
    removeCourseMaterial: '/upload/course-material/remove/',
    copyCourseMaterial: '/upload/course-material/copy/',
    updateCourseMaterial: '/upload/course-material/',
    homeworkAttachment: '/upload/homework-attachment/',
    deleteFile: '/upload/delete-file/',
    logo: '/upload/logo/',
    teacherLogo: '/upload/teacher-logo/',
    userLogo: '/upload/user-logo/',
    lessonRecording: '/upload/lesson-recording/',
  },
  collectibles: {
    getSummary: '/collectibles/summary/',
    assign: '/collectibles/assign/',
    use: '/collectibles/use/',
    leaderboard: '/collectibles/leaderboard/',
  },
  homework: {
    assign: '/homework/',
    get: '/homework/',
    edit: '/homework/',
    delete: '/homework/',
    archive: (assignmentId: string) => `/homework/${assignmentId}/archive/`,
    unarchive: (assignmentId: string) => `/homework/${assignmentId}/unarchive/`,
    postSubmission: '/homework/submission/',
    editSubmission: '/homework/submission/',
    getSubmission: '/homework/submission/',
    postFeedback: '/homework/feedback/',
    getFeedback: '/homework/feedback/',
    markFeedbackAsSeen: '/homework/feedback/mark-seen/',
  },
  notifications: {
    get: '/notifications/',
    markAsRead: '/notifications/mark-read/',
  },
  admin: {
    getStudents: 'admin/students/',
    removeStudent: 'admin/students/',
    getTeachers: 'admin/teachers/',
    removeTeacher: 'admin/teachers/',
    getCourses: 'courses/list/admin',
    getCourse: (courseId: string) => `courses/${courseId}/admin/`,
    addCourse: 'courses/create/admin/',
    enrollStudent: 'admin/enroll/student/',
    enrollTeacher: 'admin/enroll/teacher/',
    getStudent: 'admin/student/',
    editStudent: 'admin/student/',
    editStudentEmail: 'admin/student/email/',
    getTeacher: 'admin/teacher/',
    editTeacher: 'admin/teacher/',
    getSubjects: 'courses/subjects/',
    getAgencySettings: 'auth/agency-settings/',
    editAgencySettings: 'auth/agency-settings/',
    addAgencySettings: 'auth/agency-settings/',
    teacherSettings: 'auth/teacher-settings/',
    deleteCourse: (courseId: string) => `courses/${courseId}/delete/admin/`,
    editCourse: (courseId: string) => `courses/${courseId}/edit/admin/`,
    getOnlineBillingTime: 'admin/online-time-billing/',
    setupStripe: '/payments/setup-stripe/',
    setupStripeAcademy: '/payments/setup-stripe-academy/',
    getOnboardingLinkStripe: '/payments/onboarding-link-stripe/',
    getManageAccountLinkStripe: '/payments/manage-account-link-stripe/',
  },
  subscription: {
    getRenewSubscriptionLink: '/stripe/renewsubscription/',
    stripeTopUps: '/stripe/top-up/',
    purchasedStripeTopUps: '/stripe/top-up/purchased/',
  },
  payment: {
    redirectPayment: (paymentId: string) =>
      `/payments/redirect-payment/${paymentId}/`,
    redirectSubscription: (planId: string) =>
      `/payments/redirect-subscription/${planId}/`,
    getStudentPayments: '/payments/list/',
    createStudentPayment: '/payments/create/v2/',
    editStudentPayment: '/payments/edit/',
    paymentsForStudent: '/payments/student',
    markAsPaid: (paymentId: string) => `/payments/mark-as-paid/${paymentId}/`,
    deleteStudentPayment: (paymentId: string) =>
      `/payments/delete/${paymentId}/`,
    cancelSubscription: (planId: string) => `/payments/plan/cancel/${planId}/`,
    processRefund: (paymentId: string) => `/payments/refund/${paymentId}/`,
    updateLessonAllocation: (studentDetailsId: string, courseId: string) =>
      `/payments/student/${studentDetailsId}/course/${courseId}/lesson-allocation/`,
    sendReminder: '/payments/send-reminder/',
    downloadInvoice: (paymentId: string) =>
      `/payments/download-invoice/${paymentId}/`,
    getTeacherPayrollList: '/payments/teacher/list/',
    createTeacherPayroll: '/payments/teacher/create/',
    editTeacherPayroll: (payroll_id: string) =>
      `/payments/teacher/edit/${payroll_id}/`,
    deleteTeacherPayroll: (payroll_id: string) =>
      `/payments/teacher/delete/${payroll_id}/`,
    getTeacherPayroll: (teacher_id: string) =>
      `/payments/teacher/${teacher_id}/`,
    approvePayment: `/payments/approve-payout/`,
    closeBillingCycle: (billing_cycle_id: string) =>
      `/payments/billing-cycle/${billing_cycle_id}/close/`,
    createTeacherStripeAccount: '/payments/teacher/create-stripe-account/',
    getStudentCreditHistory: '/payments/student/credit-history/',
    getPaymentSummary: (payment_plan_id: string) =>
      `/payments/summary/${payment_plan_id}/`,
    getStudentCreditBalance: '/payments/student/credit-balance/',
    transferStudentCredits: '/payments/student/credit-transfer/',
  },
  petshopitems: {
    listPetshopItems: 'petshop/collectibles/',
    listMyItems: (student_id: string) => `petshop/collectibles/${student_id}/`,
    buyItem: (student_id: string) => `petshop/buy-collectible/${student_id}/`,
    buyPotion: (student_id: string) => `petshop/buy-potion/${student_id}/`,
    useItem: (student_id: string) => `petshop/use-collectible/${student_id}/`,
    removeAccessory: (student_id: string) =>
      `petshop/remove-accessory/${student_id}/`,
    buyPet: (student_id: string) => `petshop/buy-pet/${student_id}/`,
    selectPet: (student_id: string) => `petshop/select-pet/${student_id}/`,
    getStudentPets: (student_id: string) =>
      `petshop/get-student-pets/${student_id}/`,
  },
};

export default apiConfig;
